import { DataVariants } from "../../../data/DataManager";
import { FieldSchema } from "../../../Schema";


export enum Modes {
  CREATE = "create",
  EDIT = "edit",
  BULK_EDIT = "bulkEdit",
  VIEW = "view",
  /**
   * A CSV row being imported.
   *
   * The file names the master data in columns of its own — a Category cell, a Manufacturer
   * cell — where every form drives the same four fields through `masterDataPicker`. The
   * picker is rebuilt from the *stored* record on the way in, so without a mode to tell the
   * two apart the four fields would take the stored tuple and the file's columns would be
   * read and then dropped. See `equipmentCategory`, `manufacturer`, `equipmentModel` and
   * `variant`, which are the only fields that behave differently in this mode.
   */
  CSV = "csv",
}

export const mode: FieldSchema = {
  name: "mode",
  graphql: { selection: undefined },
  // Never persisted, by either route: this exists to drive the form and the schema's own
  // cross-field logic, not to be stored.
  dataTransform: { toGraphql: undefined, toDb: undefined },
  data: {
    variant: DataVariants.ENUM,
    options: Object.values(Modes),
  },
  form: { disabled: true, displayed: false },
};
